import RiskUserHistory from "./RiskUserHistory";
export default RiskUserHistory;